Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.jsVersion = void 0;
var jsVersion = exports.jsVersion = "3.5.4";
